import styles from './DailySummaryParam.module.css'

interface DailySummaryParamProps{
    caption: string,
    value: string
}

export const DailySummaryParam = (props: DailySummaryParamProps): JSX.Element => {
    const {
        caption,
        value
    } = props

    return (
        <>
            <div className={styles.DailySummaryParam__Caption}>
                {caption}:
            </div>
            <div className={styles.DailySummaryParam__Value}>
                {value}
            </div>
        </>
    )
}